<template lang="pug">
  .absolute.inset-0.flex.flex-col.justify-center.items-center.overflow-hidden
    .flex.justify-center.items-center(class="pt:-mt-8 w-full mx-auto flex-col ls:flex-row")
      .py-4(class="w-full ls:w-6/12 ls:mb-16 lg:w-5/12 lg:max-w-2xl")
        .max-w-lg.mx-auto
          slider(:stages="stages" :current="beforeStage" @slideChange="onSlideChange")
      .max-w-3xl(class="w-full md:w-9/12 ls:w-6/12 ls:order-first")
        map-nav.w-full(class="pt:-mt-16 pt:-mb-20 ls:ml-4" :stages="stages" :current="beforeStage" @hover="hoverOnMarker" @click="clickOnMarker")
</template>
<script>
import { mapGetters } from "vuex";
import Slider from "@/components/map/slider";
import MapNav from "@/components/map/map";
export default {
  data() {
    return {
      beforeStage: 0
    };
  },
  components: {
    Slider,
    MapNav
  },
  computed: {
    ...mapGetters({ stages: "stage/stages" })
  },
  mounted() {
    const from = this.$store.state.route.from;
    if (from.path.search(/stage/) > -1) {
      this.beforeStage = parseInt(from.params.id);
    }
  },
  methods: {
    onSlideChange(index) {
      this.beforeStage = parseInt(index);
    },
    hoverOnMarker(index) {
      this.beforeStage = parseInt(index);
    },
    clickOnMarker(index) {
      this.$router.push({ path: `/stage/${index}` });
    }
  }
};
</script>
